export const isSamsungTv = typeof navigator !== 'undefined' && /Tizen/i.test(navigator.userAgent || '');

export const releaseMedia = (media) => {
  if (!media) return;
  try {
    media.pause();
    media.removeAttribute('src');
    media.load();
  } catch { /* The TV may already have released the decoder. */ }
};